export default "__VITE_ASSET__DRT89zg0__"